import type { PluginManifest } from "@d12labs/plugins/types";

export const manifest: PluginManifest = {
	name: "ai-chat",
	label: "AI Chat",
	description:
		"Minimal Claude chat — demonstrates the chassis AI primitive (budget-checked + usage-logged).",
	version: "0.1.0",
	navItems: [{ label: "AI Chat", href: "/ai-chat", icon: "Sparkles" }],
};
